/*
  Copyright 2019 Bit Factory, Inc.
  This Source Code Form is subject to the terms of the Mozilla Public
  License, v. 2.0. If a copy of the MPL was not distributed with this
  file, You can obtain one at http://mozilla.org/MPL/2.0/.
*/
import Web3 from 'web3-old';
import Ethereum from 'web3';
import { ProviderMethod } from '../providers';
import { QurageLinkWeb3Provider } from '../providers/web3-provider';
import { QurageLinkEthereumProvider } from '../providers/ethereum-provider';
export class Web3Factory {
    constructor(endpoint, options) {
        this.endpoint = endpoint;
        this.options = options;
    }
    createWeb3() {
        const web3 = new Web3(this.endpoint);
        web3.setProvider(new QurageLinkWeb3Provider(this.endpoint, this.options));
        web3.eth.defaultAccount = this.options.address;
        return web3;
    }
    createEthereum() {
        const ethereum = new Ethereum(this.endpoint);
        const provider = new QurageLinkEthereumProvider(this.endpoint, this.options);
        ethereum.setProvider(provider);
        this.extendEthereum(ethereum); // XXX
        return ethereum;
    }
    extendEthereum(ethereum) {
        const provider = ethereum.currentProvider;
        const target = ethereum;
        target.selectedAddress = undefined;
        target.enable = async () => {
            const response = await this.requestAccounts(provider);
            const accounts = response.result;
            target.selectedAddress = accounts[0];
            return Promise.resolve(accounts);
        };
    }
    requestAccounts(provider) {
        return provider.send(ProviderMethod.EthRequestAccounts, []);
    }
}
